import { Icon, Text } from "@jds/core";
import classes from "./AnalyticsChart.module.css";
import { useState } from "react";
import {
  BarChart,
  Bar,
  XAxis,
  YAxis,
  Tooltip,
  ResponsiveContainer,
  Pie,
  PieChart,
  Sector,
  Rectangle,
} from "recharts";

const COLORS = [
  "#3b82f6", // blue
  "#ef4444", // red
  "#10b981", // green
  "#f59e0b", // amber
  "#8b5cf6", // purple
  "#ec4899", // pink
  "#06b6d4", // cyan
  "#f97316", // orange
  "#f43f5e", // rose
  "#14b8a6", // teal
  "#6366f1", // indigo
  "#84cc16", // lime
  "#a855f7", // violet
  "#22c55e", // green (alt)
  "#eab308", // yellow
  "#0ea5e9", // sky blue
  "#d946ef", // fuchsia
  "#facc15", // yellow (bright)
  "#fb7185", // rose (light)
  "#34d399", // emerald
  "#38bdf8", // light blue
  "#c084fc", // lavender
];
const AnalyticsChart = ({ data }) => {
  const [chartType, setChartType] = useState(0);

  const data1 = [
    {
      answer: "Nursery",
      count: 15,
    },
    {
      answer: "LKG",
      count: 45,
    },
    {
      answer: "UKG",
      count: 40,
    },
    {
      answer: "I",
      count: 1,
    },
    {
      answer: "II",
      count: 14,
    },
    {
      answer: "III",
      count: 12,
    },
    {
      answer: "IV",
      count: 0,
    },
    {
      answer: "V",
      count: 16,
    },
    {
      answer: "VI",
      count: 2,
    },
    {
      answer: "VII",
      count: 18,
    },
    {
      answer: "VIII",
      count: 89,
    },
    {
      answer: "IX",
      count: 0,
    },
    {
      answer: "X",
      count: 9,
    },
    {
      answer: "XI",
      count: 187,
    },
    {
      answer: "XII",
      count: 0,
    },
  ];

  return (
    <div className={`${classes["chart-card"]}`}>
      <div className={`${classes["chart-header"]}`}>
        <Text text={data?.questionName} appearance="body-m-bold" />
        <div className={`${classes["icon-btn-group"]}`}>
          <button
            className={`${classes["icon-btn"]} ${chartType === 0 ? classes["active"] : ""}`}
            onClick={() => setChartType(0)}
            title="Bar Chart">
            <Icon ic="IcGraphTable" />
          </button>
          <button
            className={`${classes["icon-btn"]} ${chartType === 1 ? classes["active"] : ""}`}
            onClick={() => setChartType(1)}
            title="Pie Chart">
            <Icon ic="IcAnalytics" />
          </button>
        </div>
      </div>
      <div>
        {chartType == 0 && (
          <ResponsiveContainer width="100%" height={350}>
            <BarChart data={data?.answerStats}>
              <XAxis dataKey="answer" />
              <YAxis />
              <Tooltip />
              <Bar
                shape={MyCustomRectangle}
                dataKey="count"
                fill="#3b82f6"
                radius={[6, 6, 0, 0]}
                // label={{ position: "top" }}
              />
            </BarChart>
          </ResponsiveContainer>
        )}
        {chartType == 1 && (
          <PieChart responsive height={350}>
            <Pie
              dataKey="count"
              data={data?.answerStats}
              fill="#3b82f6"
              isAnimationActive={false}
              nameKey="answer"
              shape={MyCustomPie}
            />
            <Tooltip />
          </PieChart>
        )}
      </div>
      <div className={`${classes["chart-ans-list"]}`}>
        {data?.answerStats.map((ans, index) => (
          <div className={`${classes["ans-tag"]}`}>
            <div className={`${classes["ans-question"]}`}>
              <span
                className={`${classes["ans-clr"]}`}
                style={{
                  backgroundColor: COLORS[index % COLORS.length],
                }}></span>
              <span className={`${classes["ans-name"]}`}>{ans.answer}</span>
            </div>
            <span className={`${classes["ans-count"]}`}>{ans.count}</span>
          </div>
        ))}
      </div>
    </div>
  );
};

export default AnalyticsChart;

const MyCustomPie = (props) => (
  <Sector {...props} fill={COLORS[props.index % COLORS.length]} />
);

const MyCustomRectangle = (props) => {
  return <Rectangle {...props} fill={COLORS[props.index % COLORS.length]} />;
};
